import {
  PlayersOnStandings,
  SessionLeagueDetails,
  StandingsColumn,
} from '@/modules/league/new-components/types';
import { getNumberSuffix } from '@/utils/helpers/getNumberSuffix';

export const shouldRenderColumn = (col: StandingsColumn, session: SessionLeagueDetails) => {
  const conditionKeys = col.conditionKeys;

  if (!conditionKeys) return true;

  if (conditionKeys.length === 1 && conditionKeys[0]) {
    if (col.label === 'Max Mvmt') {
      return parseFloat(session?.MaxMovementRule) * 100 > 0 && session[conditionKeys[0]] === false;
    }
    return session[conditionKeys[0]] === false;
  }

  if (conditionKeys.length > 1) {
    if (col.label === 'Group Bonus') {
      return conditionKeys.some((key) => parseFloat(String(session[key])) > 0);
    }
    return conditionKeys.some((key) => session[key] === false);
  }

  return true;
};

export function formatValueForTables(value: string, multiplier?: number) {
  let parsedValue = parseFloat(value);
  if (multiplier) {
    parsedValue *= multiplier;
  }
  if (parsedValue <= 0) {
    return '0';
  } else if (parsedValue % 1 === 0) {
    return `${parsedValue}`;
  } else {
    const factor = Math.pow(10, 3);
    const truncatedValue = Math.floor(parsedValue * factor) / factor;
    return `${truncatedValue.toFixed(3)}`;
  }
}

export function formatValueForPTS(
  session: SessionLeagueDetails,
  player: PlayersOnStandings,
  column: StandingsColumn
) {
  let displayValue = null;
  const { conditionKeys, secondaryDataKeys, primaryDataKey } = column;

  if (!conditionKeys || !primaryDataKey || !secondaryDataKeys) {
    return null;
  }

  const conditionKey1 = conditionKeys[0] as keyof SessionLeagueDetails;
  const conditionKey2 = conditionKeys[1] as keyof SessionLeagueDetails;
  const secondaryKey = secondaryDataKeys[0] as keyof PlayersOnStandings;

  if (session[conditionKey1] === false) {
    displayValue = player[primaryDataKey];
    if (session[conditionKey2] === false) {
      displayValue += ' | (' + player[secondaryKey] + ')';
    }
  } else if (session[conditionKey1] === true && session[conditionKey2] === false) {
    displayValue = '(' + player[secondaryKey] + ')';
  }
  return displayValue;
}

export function formatValueForH2H(
  session: SessionLeagueDetails,
  player: PlayersOnStandings,
  dataKey: keyof PlayersOnStandings
) {
  if (
    dataKey &&
    (player.TotalWins as number) > 0 &&
    session.IsReadOnlyMode === false &&
    session.DateCompleteAndLock === null &&
    player.UseHeadToHeadWins !== false
  ) {
    return player[dataKey];
  }
  return null;
}

export function formatValueForPlace(player: PlayersOnStandings) {
  if (player.LastGameDateGroup_Number > 0 && player.DidMissCurrentMatchDate === false) {
    return `G${player.LastGameDateGroup_Number} - ${player.LastGameDateGroup_Place}${getNumberSuffix(player.LastGameDateGroup_Place)} of
              ${player.LastGameDateGroup_Place_OutOf}`;
  }
  return '- -';
}
